function menuHover() {
    const menuItems = document.querySelectorAll('.navbar-nav--main > .nav-item--contain');

    new SV.HoverIntent(menuItems, {
        // required parameters
        onEnter: function (targetItem) {
            targetItem.classList.add('active');
            document.body.classList.add('menu-open');
        },
        onExit: function () {
            document.querySelectorAll('.navbar-nav > .nav-item').forEach((e) => {
                e.classList.remove('active');
            });
            document.body.classList.remove('menu-open');
        },
        exitDelay: 400,
        interval: 100,
        sensitivity: 7,
    });
}

function clearAllOpenCategoryLinks() {
    document.querySelectorAll('.nav-list--active').forEach((e) => {
        e.classList.remove('nav-list--active');
    });
    document.querySelector('.nav-list').classList.remove('show');
}

function clearAllOpenCategoryMobileMenu() {
    document.querySelectorAll('.nav-list--active').forEach((e) => {
        e.classList.remove('nav-list--active');
    });
    document.querySelector('.nav-list').classList.remove('show');
}

function initMobileMenuEvent() {
    Array.from(document
        .querySelector('.navbar-nav--main')
        .getElementsByClassName('nav-link--expand')
    ).forEach(element => {
        element.addEventListener('click', function (event) {
            if (
                /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
                    navigator.userAgent
                ) ||
                window.width() < 992
            ) {
                event.preventDefault();
                event.target.parentElement.classList.toggle("nav-item--active");
                event.target.nextElementSibling.classList.toggle('show');
            }
            let $root_nav_bar = event.target.closest(".navbar-nav");

            if ($root_nav_bar.classList.contains("navbar-nav--active")) {
                $root_nav_bar.classList.remove("navbar-nav--active");
                clearAllOpenCategoryMobileMenu();
            } else {
                $root_nav_bar.classList.add("navbar-nav--active");
            }
        });
    });
}

function categoryLinks() {
    if (document.querySelector('.category-list')) {
        Array.from(
            document.querySelector('.category-list').getElementsByClassName('nav-link--show')
        ).forEach(element => {
            element.addEventListener('click', function (event) {
                event.preventDefault();
                let $root_nav_link = event.target.parentElement.parentElement;

                if ($root_nav_link.classList.contains("nav-link--active")) {
                    $root_nav_link.classList.remove("nav-link--active");
                    clearAllOpenCategoryLinks();
                } else {
                    $root_nav_link.classList.add("nav-link--active");
                }

                return false;
            });
        });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    if (window.width() > 991) {
        menuHover();
    } else {
        initMobileMenuEvent();
    }
    categoryLinks();
});

window.addEventListener("resize", function () {
    if (window.width() > 991) {
        menuHover();
    } else {
        initMobileMenuEvent();
    }
});
